import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

interface AvailabilitySidebarProps {
  onDateChange?: (startDate: Date | null, endDate: Date | null) => void;
}

const AvailabilitySidebar: React.FC<AvailabilitySidebarProps> = ({ onDateChange }) => {
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);

  const handleChange = (dates: [Date | null, Date | null]) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
    onDateChange?.(start, end);
  };

  const formatDate = (date: Date | null) =>
    date ? date.toLocaleDateString(undefined, { month: "short", day: "numeric" }) : "";

  return (
    <div className="bg-white rounded-3xl border border-gray-200 p-6 shadow-md w-full transition-all duration-200 hover:shadow-lg">
      {/* Header */}
      <div className="mb-5">
        <h2 className="text-xl font-semibold text-gray-900">Check availability</h2>
        <p className="text-sm text-gray-500 mt-1">
          Select your stay dates to see availability.
        </p>
      </div>

      {/* Date Picker */}
      <div className="rounded-xl overflow-hidden border border-gray-100">
        <DatePicker
          selected={startDate}
          onChange={handleChange}
          startDate={startDate}
          endDate={endDate}
          selectsRange
          inline
          minDate={new Date()}
          monthsShown={1}
        />
      </div>

      {/* Date Summary */}
      <div className="mt-5 flex items-center justify-between bg-gray-50 px-4 py-2 rounded-xl text-sm text-gray-700">
        {startDate && endDate ? (
          <>
            <span className="font-medium">
              {formatDate(startDate)} → {formatDate(endDate)}
            </span>
            <span className="text-gray-400 text-xs">
              {Math.ceil(
                (Number(endDate) - Number(startDate)) / (1000 * 60 * 60 * 24)
              )}{" "}
              nights
            </span>
          </>
        ) : (
          <span className="text-gray-500">Select your dates</span>
        )}
      </div>

      {/* Button */}
      <button
        disabled={!startDate || !endDate}
        className={`mt-6 w-full py-3.5 rounded-full text-sm font-medium transition-all duration-200 
          ${
            startDate && endDate
              ? "bg-gray-900 text-white hover:bg-black/80 shadow-md hover:shadow-lg"
              : "bg-gray-200 text-gray-500 cursor-not-allowed"
          }`}
      >
        Check availability
      </button>
    </div>
  );
};

export default AvailabilitySidebar;
